module.exports = __webpack_public_path__ + "static/media/005.018b6306.jpg";